module.exports = __webpack_public_path__ + "img/media-console.960d81f.jpg";